<template>
    <div :class="`${isApple == true ? 'index-cont-phone' : 'index-cont'}`">
        <img :src="imgPath" v-if="imgShow" :pathName="pathName" @click="handleBack">
    </div>
</template>

<script>
    export default {
        props:{
            imgShow: {
                type: Boolean,
                default: () => {
                    return {}
                }
            },
            pathName: {
                type: String,
                default: () => {
                    return {}
                }
            }
        },
        data(){
            return{
                isApple: true,
                imgPath: '',
            }
        },
        computed:{
            themeName(){
                return this.$store.state.themeName
            }
        },
        mounted() {
            this.appDown();
        },
        methods:{
            // 判断是安卓还是ios
            appDown() {
                let _ = this;
                let u = navigator.userAgent;
                let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
                let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                if(isiOS){
                    _.isApple = true;
                    if(_.themeName == 'dark') _.imgPath = require('../../asstes/left.png')
                    if(_.themeName == 'white') _.imgPath = require('../../asstes/left-white.png')
                }else if(isAndroid){
                    _.isApple = false;
                    if(_.themeName == 'dark') _.imgPath = require('../../asstes/left-return.png')
                    if(_.themeName == 'white') _.imgPath = require('../../asstes/left-return-white.png')
                    
                }
            },
            // 回到发现主页面
            handleBack(){
                let _ = this;
                _.$router.push({name: _.pathName});
            },
        }
    }
</script>

<style scoped lang="less">
    // ios 需要左箭头，
    .index-cont-phone{
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        width: 100%;
        background-color: @primary-background-color;
        img{
            padding: 10px 0 10px 26px;
            box-sizing: border-box;
        }
    }
    // android 不需要左箭头，并往下移
    .index-cont{
        position: fixed;
        top: 20px;
        left: 0px;
        z-index: 999;
        width: 100%;
        background-color: @primary-background-color;

        img{
            margin: 17px 0 17px 24px;
            width: 24px;
            height: 24px;

        }
    }
</style>
